module.exports = __webpack_public_path__ + "static/media/IMG_9511.f468bab6.JPG";